import React, { useEffect } from 'react';
import { ArrowLeft, Home } from 'lucide-react';
import { Link, useNavigate } from 'react-router-dom';
import { useTranslation } from '../hooks/useTranslation';
import { useLanguage } from '../contexts/LanguageContext';
import { withLang } from '../components/LanguageRouter';
import Header from '../components/Header';
import Footer from '../components/Footer';

const PrivacyPolicy = () => {
  const navigate = useNavigate();
  const { t } = useTranslation();
  const { currentLanguage } = useLanguage();

  // Scroll to top when component mounts
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <div className="min-h-screen">
      <Header />
      <div className="pt-20 pb-16 bg-gray-50">
        <div className="container mx-auto px-6">
          {/* Navigation Bar */}
          <div className="mb-6 flex items-center justify-between">
            <button
              onClick={() => navigate(-1)}
              className="flex items-center text-blue-600 hover:text-blue-800 transition-colors duration-200"
            >
              <ArrowLeft className="w-5 h-5 mr-2" />
              {t('legal.goBack')}
            </button>
            <Link
              to={withLang(currentLanguage)}
              className="flex items-center text-gray-600 hover:text-blue-600 transition-colors duration-200"
            >
              <Home className="w-5 h-5 mr-2" />
              {t('footer.home')}
            </Link>
          </div>

          <div className="max-w-4xl mx-auto bg-white rounded-lg shadow-lg p-8">
            <h1 className="text-4xl font-bold text-blue-900 mb-8">{t('legal.privacy.title')}</h1>
            <p className="text-gray-600 mb-8">{t('legal.lastUpdated')}</p>

            <div className="space-y-8">
              <section>
                <h2 className="text-2xl font-bold text-blue-900 mb-4">{t('legal.privacy.section1.title')}</h2>
                <p className="text-gray-700 leading-relaxed mb-4">
                  {t('legal.privacy.section1.intro')}
                </p>
                <ul className="list-disc ml-6 text-gray-700 space-y-2">
                  {t('legal.privacy.section1.items').map((item, index) => (
                    <li key={index}>{item}</li>
                  ))}
                </ul>
              </section>

              <section>
                <h2 className="text-2xl font-bold text-blue-900 mb-4">{t('legal.privacy.section2.title')}</h2>
                <p className="text-gray-700 leading-relaxed">
                  {t('legal.privacy.section2.content')}
                </p>
              </section>

              <section>
                <h2 className="text-2xl font-bold text-blue-900 mb-4">{t('legal.privacy.section3.title')}</h2>
                <p className="text-gray-700 leading-relaxed">
                  {t('legal.privacy.section3.content')}
                </p>
              </section>

              <section>
                <h2 className="text-2xl font-bold text-blue-900 mb-4">{t('legal.privacy.section4.title')}</h2>
                <p className="text-gray-700 leading-relaxed">
                  {t('legal.privacy.section4.content')}
                </p>
              </section>

              <section>
                <h2 className="text-2xl font-bold text-blue-900 mb-4">{t('legal.privacy.section5.title')}</h2>
                <p className="text-gray-700 leading-relaxed">
                  {t('legal.privacy.section5.content')}
                </p>
              </section>

              <section>
                <h2 className="text-2xl font-bold text-blue-900 mb-4">{t('legal.privacy.section6.title')}</h2>
                <p className="text-gray-700 leading-relaxed">
                  {t('legal.privacy.section6.content')}
                </p>
              </section>
            </div>
          </div>
        </div>
      </div>
      <Footer />
    </div>
  );
};

export default PrivacyPolicy;